// ab726
import throttle from 'lodash/throttle';

$(document).ready(function () {
  const $targetElement = $('.js-filters-by-sticky');
  const $stickyElement = $('#stickyElement');
  let hasClass = false; // Track if class is already added/removed

  if($targetElement.length === 0) return;

  // Create a throttled scroll handler using Lodash
  // The function will execute at most once every 100ms
  const handleScroll = throttle(function () {
    const scrollY = window.scrollY;

    // Only add/remove class when crossing the threshold
    if (scrollY > 500 && !hasClass) {
      $targetElement.addClass('fixed');
      hasClass = true;
    } else if (scrollY <= 500 && hasClass) {
      $targetElement.removeClass('fixed');
      hasClass = false;
    }
  }, 100);

  // Attach the throttled handler to scroll event
  $(window).on('scroll', handleScroll);

  // Initial check on page load
  if (window.scrollY > 500) {
    $targetElement.addClass('fixed');
    hasClass = true;
  }
});


// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/abtest/plp-left-nav-filter-redesign-ab726.js